export default function boardNameValidator(boardName?: string, existNames?: string[]) {
  if (!boardName || boardName.length <= 0) {
    return 'Название табло не может быть пустым';
  }
  if (existNames && existNames.includes(boardName)) {
    return 'Такое название уже существует, придумайте новое';
  }
  return undefined;
}
